<div class="app-toast-container">
  <div
    *ngFor="let toast of toastService.toasts()"
    class="app-toast app-toast-{{ toast.type }}"
    (click)="dismiss(toast.id)">
    <div class="app-toast-title" *ngIf="toast.title">{{ toast.title }}</div>
    <div class="app-toast-message">{{ toast.message }}</div>
    <div class="app-toast-progress" *ngIf="toast.progressBar" [style.animation-duration.ms]="toast.timeOut"></div>
  </div>
</div>
